import { FC, Suspense, useCallback, useState } from 'react'

import { Editor } from '@tiptap/react'

import { ButtonSize } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Popover } from '@tribeplatform/react-ui-kit/Popover'

import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { EmojiPicker } from '../../Picker/EmojiPicker.js'
import { PickerEmoji } from '../../Picker/index.js'

import { ComposerIconButton } from './ComposerIconButton.js'

interface Props {
  editor: Editor
  size?: ButtonSize
  disabled?: boolean
}

export const EmojiPickerButton: FC<Props> = ({ editor, size, disabled }) => {
  const { $t } = useI18n()
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false)

  const onSelectEmoji = useCallback(
    (emoji: PickerEmoji) => {
      const position = {
        from: editor.state.selection.from,
        to: editor.state.selection.to,
      }

      editor
        .chain()
        .focus()
        .insertContentAt(position, [
          {
            type: 'text',
            text: emoji.native,
          },
          {
            type: 'text',
            text: ' ',
          },
        ])
        .run()
    },
    [editor],
  )

  const activator = (
    <ComposerIconButton
      icon={<SvgIcon name="emotion" />}
      aria-label={$t({
        id: 'Generics.Emoji',
        defaultMessage: 'Emoji',
      })}
      size={size}
      onClick={() => setIsEmojiPickerOpen(!isEmojiPickerOpen)}
      disabled={disabled}
    />
  )

  return (
    <Popover
      placement="top-start"
      activator={activator}
      open={isEmojiPickerOpen}
      onClose={() => setIsEmojiPickerOpen(false)}
    >
      <Suspense fallback={<></>}>
        <EmojiPicker onEmojiChange={onSelectEmoji} />
      </Suspense>
    </Popover>
  )
}
